export const overlayClassName = 'styled-react-modal-overlay';
export const modalClassName = 'styled-react-modal-modal';
